module.exports = __webpack_public_path__ + "images/般蓝pr长图_06.jpg?v=9a8744d3";


/*****************
 ** WEBPACK FOOTER
 ** ./src/images/home/quanjing/zhongduan3/般蓝pr长图_06.jpg
 ** module id = 183
 ** module chunks = 1 2
 **/